import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { testimonials } from '../data/testimonials';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function TestimonialsSection() {
  return <section className="bg-mp-dark py-16 md:py-20" data-id="element-279" data-mp="1r0ucuqpv66le">
      <Container data-id="element-280" data-mp="1qzj7wnkomssp">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:gap-6" data-id="element-281" data-mp="1d1uo7j2cprp8">
          {testimonials.map((t, i) => <motion.div key={t.author} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i * 0.05
        }} className="rounded-2xl border border-mp-border bg-mp-card p-7" data-id="element-282" data-mp="1i17igovjy11u" data-mpi={i}>
              <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-283" data-mp="32gj0lkaxz9n9">
                {Array.from({
              length: 5
            }).map((_, idx) => <StarIcon key={idx} className="h-4 w-4 fill-mp-lime text-mp-lime" data-id="element-284" data-mp="2v09n8m63ey3l" data-mpi={idx} />)}
              </div>
              <p className="mt-4 text-base leading-relaxed text-mp-white md:text-[17px]" data-id="element-285" data-mp="2q27wdf2fduhk">"{t.quote}"</p>
              <p className="mt-4 text-sm text-mp-gray" data-id="element-286" data-mp="34tgp3x1mjvyx">
                — {t.author}, {t.role} · {t.location}
              </p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}